import * as React from 'react';

interface IRegionSelectForm {
    channel: string;
    regions?: string;
    value: string;
    name: string;
}

class RegionSelect extends React.Component<IRegionSelectForm> {
    public renderAustraliaIcon = (value) => {
        if (value === 'australia_new_zealand') {
            return (
                <div className="icon-selected-container region-icon-selected">
                    <img src={require('./img/icon_australia_selected.png')} alt="australia"/>
                </div>
            );
        }
        return (
            <div className="icon-container region-icon">
                <img src={require('./img/icon_australia.png')} alt="australia"/>
            </div>
        );
    }

    public renderEuropeIcon = (value) => {
        if (value === 'europe') {
            return (
                <div className="icon-selected-container region-icon-selected">
                    <img src={require('./img/icon_europe_selected.svg')} alt="europe"/>
                </div>
            );
        }
        return (
            <div className="icon-container region-icon">
                <img src={require('./img/icon_europe.png')} alt="europe"/>
            </div>
        );
    }

    public renderWorldWideIcon = (value) => {
        if (value === 'worldwide') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_worldwide_selected.png')} alt="australia"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_worldwide.png')} alt="worldwide"/>
            </div>
        );
    }

    public renderRenewalIcon = () => {
        const { channel } = this.props;

        if (['npo-b2c', 'npor-b2c', 'cspa-b2c', 'cspar-b2c', 'css-b2c', 'cssr-b2c'].includes(channel)) {
            return (
                <div className="icon-container mobile-margin-top">
                    <img src={require('./img/icon_renew_blue.svg')} alt="Renewal Date"/>
                </div>
            );
        }

        return (
            <div className="icon-container mobile-margin-top">
                <img src={require('./img/icon_renew_red.svg')} alt="Renewal Date"/>
            </div>
        );
    }

    public renderWorldWideExcludingIcon = (value) => {
        if (value === 'worldwide_excluding') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_worldwide_selected.png')} alt="australia"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_worldwide.png')} alt="worldwide excluding"/>
            </div>
        );
    }

    public renderUkIcon = (value) => {
        if (value === 'uk') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_uk_selected.svg')} alt="uk"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_uk.png')} alt="uk"/>
            </div>
        );
    }

    public renderChannelIcon = (value) => {
        if (value === 'channel_islands') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_channel_selected.svg')} alt="channel islands"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_channel.svg')} alt="channel islands"/>
            </div>
        );
    }

    public renderEuropeAreaOneIcon = (value) => {
        if (value === 'europe_area_1') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_europe_selected_area1.svg')} alt="Europe Area 1"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_europe_unselected_area1.svg')} alt="Europe Area 1"/>
            </div>
        );
    }

    public renderEuropeAreaTwoIcon = (value) => {
        if (value === 'europe_area_2') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_europe_selected_area2.svg')} alt="Europe Area 2"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_europe_unselected_area2.svg')} alt="Europe Area 2"/>
            </div>
        );
    }

    public renderEuropeAreaThreeIcon = (value) => {
        if (value === 'europe_area_3') {
            return (
                <div className="icon-selected-container">
                    <img src={require('./img/icon_europe_selected_area3.svg')} alt="Europe Area 3"/>
                </div>
            );
        }
        return (
            <div className="icon-container">
                <img src={require('./img/icon_europe_unselected_area3.svg')} alt="Europe Area 3"/>
            </div>
        );
    }

    public render() {
        const { name, value } = this.props;
        let render;
        switch (name) {
            case 'australia_new_zealand':
                render = this.renderAustraliaIcon(value);
                break;
            case 'worldwide':
                render = this.renderWorldWideIcon(value);
                break;
            case 'renewal':
                render = this.renderRenewalIcon();
                break;
            case 'europe':
                render = this.renderEuropeIcon(value);
                break;
            case 'uk':
                render = this.renderUkIcon(value);
                break;
            case 'worldwide_excluding':
                render = this.renderWorldWideExcludingIcon(value);
                break;
            case 'channel_islands':
                render = this.renderChannelIcon(value);
                break;
            case 'europe_area_1':
                render = this.renderEuropeAreaOneIcon(value);
                break;
            case 'europe_area_2':
                render = this.renderEuropeAreaTwoIcon(value);
                break;
            case 'europe_area_3':
                render = this.renderEuropeAreaThreeIcon(value);
                break;
        }
        return (
            <div className="destination-image">
                {render}
            </div>
        );
    }
}

export default RegionSelect;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/TripDetails/components/RegionSelect/RegionSelect.tsx